export const OccupancyType = {
    CONVENTIONAL: 1,
    COMMERCIAL: 2,
    OTHER_INCOME: 4,
    PROPERTY: 5,
    AFFORDABLE: 6,
    OWNER: 7,
    LENDER: 8,
    MILITARY: 9,
    STUDENT: 10,
    HOSPITALITY: 12,
    MANUFACTURED_HOUSING: 13,
} as const;

// Export individual constants for convenience
export const {CONVENTIONAL} = OccupancyType;
export const {COMMERCIAL} = OccupancyType;
export const {OTHER_INCOME} = OccupancyType;
export const {PROPERTY} = OccupancyType;
export const {AFFORDABLE} = OccupancyType;
export const {OWNER} = OccupancyType;
export const {LENDER} = OccupancyType;
export const {MILITARY} = OccupancyType;
export const {STUDENT} = OccupancyType;
export const {HOSPITALITY} = OccupancyType;
export const {MANUFACTURED_HOUSING} = OccupancyType;

// Type for OccupancyType values
export type OccupancyTypeValue = (typeof OccupancyType)[keyof typeof OccupancyType];

/** Occupancy type IDs supported by the waitlist feature. */
export const WAITLIST_OCCUPANCY_IDS: readonly number[] = [CONVENTIONAL, AFFORDABLE, STUDENT] as const;

/** Subsidy type ID for Tax Credit — default selection for Affordable Program Type filter. */
export const AFFORDABLE_DEFAULT_SUBSIDY_TYPE_ID = 2;

/** Subsidy type ID for HUD — used for column-visibility logic. */
export const HUD_SUBSIDY_TYPE_ID = 1;
